export const UPDATE_PROFILE = 'user/UPDATE_PROFILE'
export const SET_PROFILE = 'user/SET_PROFILE'
export const SET_REGISTRATION = 'user/SET_REGISTRATION'
